function mdBlur($mdUtil, $timeout): Object {
    return {
        require: "^mdAutocomplete",
        link: ($scope, $element, $attributes, $mdAutocompleteCtrl) => {
            $timeout(() => {
                const nativeBlur = $mdAutocompleteCtrl.blur;
                $mdAutocompleteCtrl.blur = () => {
                    nativeBlur.call($mdAutocompleteCtrl);
                    $mdUtil.nextTick(() => {
                        $scope.$eval($attributes.mdBlur, {"$mdAutocomplete": $mdAutocompleteCtrl });
                    });
                };
            });
        }
    };
}

mdBlur.$inject = ["$mdUtil", "$timeout"];

angular
    .module("thor.core.mdBlur.directive", [])
    .directive("mdBlur", mdBlur);
